const actions = {
  getContabilista({ commit }) {
    commit("GET_CONTABILISTA");
  },

  setContabilista({ commit }, contabilista) {
    commit("SET_CONTABILISTA", contabilista);
  },
};

export default actions;
